<p-panel header="Seleccione un banco haciendo doble click">
  @if (loaded) {
    <div >
      <p-table
        [value]="lsData"
        [paginator]="true"
        [rows]="4"
        [totalRecords]="totalRows"
        [sortField]="'Codigo'"
        [sortOrder]="1"
        styleClass="font-size: 12px; p-datatable-sm;"
        [showCurrentPageReport]="true"
        scrollDirection="both"
        currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros" >
        <ng-template pTemplate="header" let-columns>
          <tr class="header-table">
            <th scope="col" pSortableColumn="Codigo">
              <div style="text-align: center;">
                Código<p-sortIcon field="Codigo"></p-sortIcon>
              </div>
            </th>
            <th scope="col" pSortableColumn="Nombre">
              <div style="text-align: center;">
                Nombre<p-sortIcon field="Nombre"></p-sortIcon>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="col" [hidden]="true">
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="Codigo"
                      matchMode="contains"
                      [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
            <th scope="col">
              <p-columnfilter type="text" field="Nombre"
                      matchMode="contains"
                      [showMenu]="false" (paste)="onKeyDownLettersAndNumbers($event)" (keypress)="onKeyDownLettersAndNumbers($event)"></p-columnfilter>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dataTipoItem let-rowIndex="rowIndex">
          <tr style="cursor: pointer;" [pSelectableRow]="dataTipoItem" (dblclick)="onRowDblClick($event, dataTipoItem)">
            <td [hidden] = "true">
              {{dataTipoItem.Id}}
            </td>
            <td class="center">
              {{dataTipoItem.Codigo}}
            </td>
            <td class="center">
              {{dataTipoItem.Nombre}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="3">No existen registros.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  } @else {
    <app-table-skeleton [columns]="2" [rows]="6"/>
  }
</p-panel>

